import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import IconLargeCicle from '../../shared/IconLargeCicle';
import CircularProgress from '@mui/material/CircularProgress';
import {
  useConfirScheduleByIdMutation,
  useVerifyActiveScheduleByIdMutation,
  VerifyActiveScheduleDTO
} from '../../../services/schedule.service';
import { formatDateLabel } from '../../../lib/dayjs';
import { dynamicCustomEventTracking } from '../../../lib/gtm';
import ExpiredConfirmationSchedule from '../ExpiredConfirmationSchedule';

export default function ConfirmationScheduleRoot() {
  const [isLoading, setIdLoading] = useState(true);
  const [isExpire, seIsExpire] = useState(true);
  const { scheduleId } = useParams();
  const [schedule, setSchedule] = useState<VerifyActiveScheduleDTO>();
  const [verifyActiveScheduleById] = useVerifyActiveScheduleByIdMutation();
  const [confirScheduleById] = useConfirScheduleByIdMutation();

  useEffect(() => {
    verifyActiveScheduleById({ id: scheduleId || '' })
      .unwrap()
      .then(res => {
        if (!res) {
          seIsExpire(true);
          setIdLoading(false);
          return;
        }
        setSchedule(res);
      })
      .catch(() => {
        seIsExpire(true);
        setIdLoading(false);
      });
  }, []);

  useEffect(() => {
    if (schedule) {
      confirScheduleById({ id: schedule.id || '', token: schedule.token || '' })
        .unwrap()
        .then(() => {
          seIsExpire(false);
          setIdLoading(false);
          dynamicCustomEventTracking.send({ dynamicEventName: 'confirmation_schedule_mc' });
        });
    }
  }, [schedule]);

  if (isLoading) {
    return <CircularProgress sx={{ color: 'brand.darkGreen' }} />;
  }

  if (isExpire) {
    return <ExpiredConfirmationSchedule />;
  }

  return (
    <>
      <IconLargeCicle>
        <CheckIcon />
      </IconLargeCicle>

      <Typography variant="h2" sx={{ mb: 3 }}>
        Sua consulta está confirmada!
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        A Dra {schedule?.user?.name} está te aguardando no dia {formatDateLabel(schedule?.dateStart || '')}.
      </Typography>
    </>
  );
}
